import axiosInstance from "../../axios/axios";
import { END_POINTS } from "../../shared";
import { useEncryptService } from "../../shared/hooks";
import { authActions } from "../../store/authSlice";
import { useDispatch } from "react-redux";

const useDashboardService = () => {
  const { doEncrypt } = useEncryptService();
  const dispatch = useDispatch();

  const fetchOnPremRegionWiseData = async (reqPayload: object) => {
    try {
      const response = await axiosInstance.post(
        END_POINTS.DASHBOARD_REGION_WISE,
        reqPayload
      );
      return { data: response.data.data, error: null };
    } catch (error) {
      console.error(error);
      return { data: null, error };
    }
  };
  const fetchCloudAccounts = async () => {
    try {
      const response = await axiosInstance.get(
        END_POINTS.DASHBOARD_CLOUD_ACCOUNTS
      );
      return { data: response.data.data.cloud_accounts, error: null };
    } catch (error) {
      console.error(error);
      return { data: null, error };
    }
  };
  const fetchCloudByLowestScore = async () => {
    try {
      const response = await axiosInstance.get(
        END_POINTS.DASHBOARD_ASSESTS_LOWEST_SCORE, {
        params: {
          module: 'cloud'
        }
      }
      );
      return { data: response.data.data.device_list, error: null };
    } catch (error) {
      console.error(error);
      return { data: null, error };
    }
  };
  const fetchCloudByLowestCompliance = async () => {
    try {
      const response = await axiosInstance.get(
        END_POINTS.DASHBOARD_CLOUD_LOWEST_COMPLIANCE, {
        params: {
          module: 'cloud'
        }
      }
      );
      return { data: response.data.data.device_list, error: null };
    } catch (error) {
      console.error(error);
      return { data: null, error };
    }
  };
  const fetchTagsData = async () => {
    try {
      const response = await axiosInstance.get(END_POINTS.DASHBOARD_TAGS);
      return { data: response.data.data, error: null };
    } catch (error) {
      console.error(error);
      return { data: null, error };
    }
  };

  // Fetch assets with security risk (with pagination support)
  const fetchAssetsWithSecurityRisk = async (
    module: string,
    params?: {
      page?: number;
      page_size?: number;
      sort_by?: string;
      sort_order?: "asc" | "desc";
    }
  ) => {
    try {
      const response = await axiosInstance.get(
        END_POINTS.DASHBOARD_ASSESTS_LOWEST_SCORE,
        {
          params: {
            feature: 'dashboard',
            module,
            page: params?.page ?? 1,
            page_size: params?.page_size ?? 20,
            sort_by: params?.sort_by ?? "cve_score",
            sort_order: params?.sort_order ?? "asc",
          },
        }
      );

      // Extract from response.data.data (API wraps in data object)
      const responseData = response.data?.data ?? {};
      const {
        device_list = [],
        pagination = {},
        sort = {},
      } = responseData;

      // Dispatch assets data to store if available
      if (response.status === 200 && device_list.length > 0) {
        // const assetsDetails = device_list.map((data: any) => ({
        //   device_name: data.device_name,
        //   device_id: data.id,
        // }));
        // dispatch(
        //   authActions.login({
        //     assetsData: assetsDetails,
        //   })
        // );
      }

      return {
        data: Array.isArray(device_list) ? device_list : [],
        pagination: {
          page: pagination.page ?? 1,
          page_size: pagination.page_size ?? 20,
          total_count: pagination.total_count ?? 0,
          total_pages: pagination.total_pages ?? 1,
          has_next: pagination.has_next ?? false,
          has_previous: pagination.has_previous ?? false,
        },
        sort,
        error: null,
      };
    } catch (error) {
      console.error("❌ Error fetching assets with security risk:", error);
      return { data: [], pagination: null, sort: null, error };
    }
  };

  const fetchOnPremLowestScore = async () => {
    try {
      const response = await axiosInstance.get(
        END_POINTS.DASHBOARD_ASSESTS_LOWEST_SCORE, {
        params: {
          module: 'on_premise'
        }
      }
      );
      if (response.status==200 && response.data?.data?.device_list) {
        const assetsDetails = response.data?.data?.device_list?.map((data: any) => ({
              device_name: data.device_name,
              device_id: data.id,
            }));
            dispatch(
              authActions.login({
                assetsData: assetsDetails,
              })
            );
      }
      return { data: response.data?.data?.device_list, error: null };
    } catch (error) {
      console.error(error);
      return { data: null, error };
    }
  };

  const fetchOnPremLowestcveScore = async (
    params?: {
      page?: number;
      page_size?: number;
      sort_by?: string;
      sort_order?: "asc" | "desc";
    }
  ) => {
    try {
      const response = await axiosInstance.get(
        END_POINTS.ONPREM_ASSETS_LOWEST_CVE_SCORE,
        {
          params: {
            feature: 'dashboard',
            module: "on_premise",
            page: params?.page ?? 1,
            page_size: params?.page_size ?? 20,
            sort_by: params?.sort_by ?? "cve_score",
            sort_order: params?.sort_order ?? "asc",
          },
        }
      );

      // Extract from response.data.data (API wraps in data object)
      const responseData = response.data?.data ?? {};
      const {
        device_list = [],
        pagination = {},
        sort = {},
      } = responseData;

      return {
        data: Array.isArray(device_list) ? device_list : [],
        pagination: {
          page: pagination.page ?? 1,
          page_size: pagination.page_size ?? 20,
          total_count: pagination.total_count ?? 0,
          total_pages: pagination.total_pages ?? 1,
          has_next: pagination.has_next ?? false,
          has_previous: pagination.has_previous ?? false,
        },
        sort,
        error: null,
      };
    } catch (error) {
      console.error("❌ Error fetching assets with low CVE score:", error);
      return { data: [], pagination: null, sort: null, error };
    }
  };

  const fetchOnPremLowestCompliance = async () => {
    try {
      const response = await axiosInstance.get(
        END_POINTS.ONPREM_ASSETS_LOWEST_COMPLIANCE, {
        params: {
          module: 'on_premise'
        }
      }
      );
      return { data: response.data.data.device_list, error: null };
    } catch (error) {
      console.error(error);
      return { data: null, error };
    }
  };

  // Fetch top misconfigurations
  const fetchTopMisconfigurations = async (
    payload: { type?: number },
    module: string,
    params?: {
      page?: number;
      page_size?: number;
      sort_by?: string;
      sort_order?: "asc" | "desc";
    }
  ) => {
    try {
      const response = await axiosInstance.get(
        END_POINTS.DASHBOARD_TOP_MISCONFIGURATIONS,
        {
          params: {
            feature: 'dashboard',
            module,
            page: params?.page ?? 1,
            page_size: params?.page_size ?? 20,
            sort_by: params?.sort_by ?? "severity",
            sort_order: params?.sort_order ?? "desc",
          },
        }
      );

      // Extract from response.data.data (API wraps in data object)
      const responseData = response.data?.data ?? {};
      const {
        indexes = [],
        pagination = {},
        sort = {},
      } = responseData;

      return {
        data: Array.isArray(indexes) ? indexes : [],
        pagination: {
          page: pagination.page ?? 1,
          page_size: pagination.page_size ?? 20,
          total_count: pagination.total_count ?? 0,
          total_pages: pagination.total_pages ?? 1,
          has_next: pagination.has_next ?? false,
          has_previous: pagination.has_previous ?? false,
        },
        sort,
        error: null,
      };
    } catch (error) {
      console.error("❌ Error fetching top misconfigurations:", error);
      return { data: [], pagination: null, sort: null, error };
    }
  };

  // Fetch assets with compliance risk
  const fetchAssetsCompliance = async (
    module: string,
    params?: {
      page?: number;
      page_size?: number;
      sort_by?: string;
      sort_order?: "asc" | "desc";
    }
  ) => {
    try {
      const response = await axiosInstance.get(
        END_POINTS.ONPREM_ASSETS_LOWEST_COMPLIANCE,
        {
          params: {
            feature: 'dashboard',
            module,
            page: params?.page ?? 1,
            page_size: params?.page_size ?? 20,
            sort_by: params?.sort_by ?? "name",
            sort_order: params?.sort_order ?? "asc",
          },
        }
      );

      // Extract from response.data.data (API wraps in data object)
      const responseData = response.data?.data ?? {};
      const {
        device_list = [],
        pagination = {},
        sort = {},
      } = responseData;

      return {
        data: Array.isArray(device_list) ? device_list : [],
        pagination: {
          page: pagination.page ?? 1,
          page_size: pagination.page_size ?? 20,
          total_count: pagination.total_count ?? 0,
          total_pages: pagination.total_pages ?? 1,
          has_next: pagination.has_next ?? false,
          has_previous: pagination.has_previous ?? false,
        },
        sort,
        error: null,
      };
    } catch (error) {
      console.error("❌ Error fetching assets compliance:", error);
      return { data: [], pagination: null, sort: null, error };
    }
  };

  // Fetch top CVEs with pagination support
  const fetchTopCves = async (
    payload: { type?: number },
    module: string = "on_premise",
    params?: {
      page?: number;
      page_size?: number;
      sort_by?: string;
      order?: "asc" | "desc";
    }
  ) => {
    try {
      // Build query parameters (only module)
      const queryParams = new URLSearchParams({
        module
      });

      const url = `${END_POINTS.DASHBOARD_TOP_CVES}?${queryParams.toString()}`;
      
      // Send all parameters in the request body
      const requestBody = {
        ...payload,
        feature: 'dashboard',
        page: params?.page ?? 1,
        page_size: params?.page_size ?? 20,
        sort_by: params?.sort_by || "asset_count",
        order: params?.order || "desc",
      };
      
      console.log("🔗 CVE API URL:", url, "Body:", requestBody); // Debug log
      
      const response = await axiosInstance.post(url, requestBody);

      // Extract from response.data.data (API wraps in data object)
      const responseData = response.data?.data ?? {};
      const {
        cve_list = [],
        pagination = {},
        sort = {},
      } = responseData;

      return {
        data: Array.isArray(cve_list) ? cve_list : [],
        pagination: {
          page: pagination.page ?? 1,
          page_size: pagination.page_size ?? 20,
          total_count: pagination.total_count ?? 0,
          total_pages: pagination.total_pages ?? 1,
          has_next: pagination.has_next ?? false,
          has_previous: pagination.has_previous ?? false,
        },
        sort,
        error: null,
      };
    } catch (error) {
      console.error("❌ Error fetching top CVEs:", error);
      return { data: [], pagination: null, sort: null, error };
    }
  };

  const fetchRecentTickets = async () => {
    try {
      const response = await axiosInstance.get(
        END_POINTS.DASHBOARD_RECENT_TICKETS,
        { params: { feature: 'dashboard' } }
      );
      return { data: response.data.data.tickets, error: null };
    } catch (error) {
      console.error(error);
      return { data: null, error };
    }
  };

  const fetchCyberResilienceTrend = async () => {
    try {
      const payload = {
        duration: "custom_date_range",
        start_date: "2025-01-02",
        end_date: "2025-04-16",
        device_uuid: "518389d4-6a29-451f-ab69-5e20bb5740b8",
        timezone: "Asia/Calcutta"
      };

      const response = await axiosInstance.post(
        END_POINTS.DASHBOARD_CYBER_RESILIENCE_TREND,
        payload
      );
      return { data: response.data.data, error: null };
    } catch (error) {
      console.error("Error fetching cyber resilience trend:", error);
      return { data: null, error };
    }
  };

  return {
    fetchOnPremRegionWiseData,
    fetchCloudAccounts,
    fetchCloudByLowestScore,
    fetchCloudByLowestCompliance,
    fetchTagsData,
    fetchOnPremLowestScore,
    fetchOnPremLowestcveScore,
    fetchOnPremLowestCompliance,
    fetchTopMisconfigurations,
    fetchAssetsCompliance,
    fetchAssetsWithSecurityRisk,
    fetchTopCves,
    fetchRecentTickets,
    fetchCyberResilienceTrend
  };
};

export default useDashboardService;